export enum TestnetChain {
  EthereumSepolia = 'ethereum-sepolia',
  ArbitrumSepolia = 'arbitrum-sepolia',
  BaseSepolia = 'base-sepolia',
  SolanaDevnet = 'solana-devnet',
}

export interface ValidationInput {
  chain: TestnetChain
  walletAddress: string
}

export interface SolanaTransactionKey {
  pubkey: string
  isSigner: boolean
  isWritable: boolean
}

export interface SolanaInstruction {
  keys: SolanaTransactionKey[]
  programId: string
  data: number[] | string
}

export interface SolanaTransaction {
  recentBlockhash: string
  feePayer: string
  nonceInfo: null
  instructions: SolanaInstruction[]
  signers: string[]
}

export interface EIP712TypedData {
  domain: {
    name: string
    version: string
    chainId: number
    verifyingContract: `0x${string}`
  }
  types: Record<string, unknown>
  primaryType: string
  message: Record<string, unknown>
}

export interface EIP1559Transaction {
  to: `0x${string}`
  value: `0x${string}`
  data: `0x${string}`
  gasLimit: `0x${string}`
  maxFeePerGas: `0x${string}`
  maxPriorityFeePerGas: `0x${string}`
  nonce: `0x${string}`
  chainId: number
}

export type ChainPayload =
  | EIP712TypedData
  | EIP1559Transaction
  | SolanaTransaction

export interface EIP712SigningPayload {
  chain:
    | TestnetChain.EthereumSepolia
    | TestnetChain.ArbitrumSepolia
    | TestnetChain.BaseSepolia
  walletAddress: string
  payload: EIP712TypedData
}

export interface EIP1559SigningPayload {
  chain:
    | TestnetChain.EthereumSepolia
    | TestnetChain.ArbitrumSepolia
    | TestnetChain.BaseSepolia
  walletAddress: string
  payload: EIP1559Transaction
}

export interface SolanaSigningPayload {
  chain: TestnetChain.SolanaDevnet
  walletAddress: string
  payload: SolanaTransaction
}

export type SigningPayload =
  | EIP712SigningPayload
  | EIP1559SigningPayload
  | SolanaSigningPayload

export interface SignatureInput {
  signature: string
}

export interface ValidationResult {
  success: boolean
  message: string
  details?: string
}

export interface PayloadGenerator {
  generateSigningPayload(input: ValidationInput): SigningPayload
}

export interface SignatureValidator {
  validateSignature(
    payload: SigningPayload,
    signature: SignatureInput,
  ): Promise<ValidationResult>
}
